import en from 'vuetify/es5/locale/en'
// import ru from 'vuetify/es5/locale/ru';
// import zh from 'vuetify/es5/locale/zh-Hans';
import es from 'vuetify/es5/locale/es'

const locales = { es, en } // ru, zh };

export default locales
